import AddIcon from "PFIcons/add.svg";
import React from "react";
import { useTranslation } from "react-i18next";

import { useExportWizardModalContext } from "../../../export_wizard";
import { LinkButton } from "./link_button";

export const AddNewExportReport = (): JSX.Element => {
  const { open } = useExportWizardModalContext();
  const { t } = useTranslation("bookingModule");

  return (
    <div>
      <LinkButton onClick={() => open()}>
        <AddIcon height={20} width={20} />
        <span>{t("reports.manageReports.addNew")}</span>
      </LinkButton>
    </div>
  );
};
